<template>
  <modal ref="modal" contentClasses="px-5 py-4" :hidesOnClickOut="false">
    <template v-slot:header>
      <p class="font-weight-semibold text-center">{{ title() }}</p>
    </template>

    <template v-slot>
      <display-errors tag="edit_visit_modal"></display-errors>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Contatto</label>
            <place-select
              :idSelected="resource.placeId"
              :disabled="lockPlaceSelection"
              @change="onPlaceSelected"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Data</label>
            <input
              class="form-control grey w-100"
              type="date"
              v-model="resource.date"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Tipologia</label>
            <typology-select
              :idSelected="resource.typology"
              @change="onTypologySelected"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Note</label>
            <textarea
              class="form-control grey multiline notes"
              type="text"
              v-model="data.text"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="row w-100">
        <div class="col-6 pl-0">
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            @click.prevent="onCancel"
          >
            Annulla
          </button>
        </div>
        <div class="col-6 pr-0">
          <button
            type="submit"
            class="btn btn-primary w-100"
            @click.prevent="save"
            :disabled="!valid"
            v-if="!http.loading"
          >
            Conferma
          </button>

          <loader v-else :loading="http.loading" class="text-center" />
        </div>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from "vue-property-decorator";
import { Visit } from "models";
import { Getter } from "vuex-class";
import VisitsMixin from "mixins/http/VisitsMixin";
import { RegisterHttp } from "utils/Decorators";
import { RequestData } from "store/types";
import Modal from "components/Modal.vue";
import ModelSelect from "components/ModelSelect.vue";
import PlaceSelect from "components/Place/Select.vue";
import Loader from "vue-spinner/src/PulseLoader.vue";
import TypologySelect from "./TypologySelect.vue";
import "moment";
const moment = require("moment");

@Component({
  components: { Modal, ModelSelect, Loader, PlaceSelect, TypologySelect },
})
export default class VisitCreate extends Mixins(VisitsMixin) {
  @Prop({
    default: () => {
      return {};
    },
  })
  resource?: Visit;

  @Getter
  currentUser;

  @Prop({ default: false })
  lockPlaceSelection?: boolean;

  data: any = this.resource;

  private visit = { ...this.resource };
  private httpTag = "edit_visit_modal";

  @RegisterHttp("edit_visit_modal") http: RequestData;

  mounted() {
    this.onPlaceSelected(this.resource.placeId);
    this.onTypologySelected(this.resource.typology);
  }

  get valid() {
    return this.data.date && this.data.place_id && this.data.text;
  }

  title(): string {
    return "Modifica visita";
  }

  show() {
    const modal = this.$refs.modal as any;
    modal.show();
  }

  onPlaceSelected(value) {
    this.$set(this.data, "place_id", value);
  }

  onTypologySelected(value) {
    this.$set(this.data, "typology", value);
  }

  hide() {
    const modal = this.$refs.modal as any;
    modal.hide();
  }

  onDateChanged(data) {
    this.$set(this.data, "date", moment(data).format("YYYY-MM-DD"));
  }

  reset() {
    this.resource = null;
    this.data = null;
  }

  get updateParams() {
    let data = {
      ...this.data,
    };
    return data;
  }

  save() {
    this.updateVisit(this.updateParams, this.httpTag).then(
      (resp) => {
        this.onSaved(resp);
      },
      (err) => {},
    );
  }

  onSaved(resp) {
    this.hide();
    this.$emit("updated", resp);
  }

  onCancel() {
    this.hide();
    this.$emit("canceled");
  }
}
</script>

<style scoped>
.notes {
  height: 150px;
}
</style>
